// Partner form functionality
// Extracted from mercury_provider/new_partner.html.slim inline script

document.addEventListener('DOMContentLoaded', () => {
  const partnerForm = document.getElementById('new_partner')

  if (!partnerForm) return

  let completingRegistration = false

  partnerForm.addEventListener('submit', (event) => {
    if (!completingRegistration) {
      completingRegistration = true

      const creatingAccountMessage = document.getElementById('creating-account-message')
      const partnerFormSection = document.getElementById('partner-form')
      const accountDetails = document.getElementById('account-details')
      const planDetails = document.getElementById('plan-details')
      const userHeader = document.getElementById('user-header')

      if (creatingAccountMessage) {
        creatingAccountMessage.style.display = 'block'
      }
      if (partnerFormSection) {
        partnerFormSection.style.display = 'none'
      }
      if (accountDetails) {
        accountDetails.style.display = 'none'
      }
      if (planDetails) {
        planDetails.style.display = 'none'
      }
      if (userHeader) {
        userHeader.style.display = 'none'
      }

      return true
    } else {
      event.preventDefault()
      return false
    }
  })
})
